import { Inject, Prop, Component, Vue, Provide } from 'vue-property-decorator';
import axios from 'axios';
import $ from 'jquery';
import VueFormGenerator from 'vue-form-generator';
import PageBuilderRow from './pageBuilderRow/PageBuilderRow';
import PageBuilderBlock from './pageBuilderBlock/PageBuilderBlock';
import AccordionBlock from './pageBuilderBlock/types/accordionBlock/AccordionBlock';
import SliderBlock from './pageBuilderBlock/types/sliderBlock/SliderBlock';
import ImageGalleryBlock from './pageBuilderBlock/types/imageGalleryBlock/ImageGalleryBlock';
import FormBuilderBlock from './pageBuilderBlock/types/formBuilderBlock/FormBuilderBlock';
import VarietiesBlock from './pageBuilderBlock/types/varietiesBlock/VarietiesBlock';
import EventDetailBlock from './pageBuilderBlock/types/eventDetailBlock/EventDetailBlock';
import EventHighlightsBlock from './pageBuilderBlock/types/eventHighlightsBlock/EventHighlightsBlock';
import EventTimelineBlock from './pageBuilderBlock/types/eventTimelineBlock/EventTimelineBlock';
import CategoryBlock from './pageBuilderBlock/types/categoryBlock/CategoryBlock';
import ImageButtonLinkBlock from './pageBuilderBlock/types/imageButtonLinkBlock/ImageButtonLinkBlock';

Vue.use(VueFormGenerator);

Vue.component('page-builder-row', PageBuilderRow);
Vue.component('page-builder-block', PageBuilderBlock);
Vue.component('accordion-block', AccordionBlock);
Vue.component('slider-block', SliderBlock);
Vue.component('image-gallery-block', ImageGalleryBlock);
Vue.component('form-builder-block', FormBuilderBlock);
Vue.component('vue-form-generator', VueFormGenerator.component);
Vue.component('varieties-block', VarietiesBlock);
Vue.component('event-detail-block', EventDetailBlock);
Vue.component('event-highlights-block', EventHighlightsBlock);
Vue.component('event-timeline-block', EventTimelineBlock);
Vue.component('category-block', CategoryBlock);
Vue.component('image-button-link-block', ImageButtonLinkBlock);

export default {

  name: 'page-builder',

  props: [
    'uuid',
    'contentName',
    'formData',
    'passDataToChildren'
  ],

  inject: [
    'pageBuilderData'
  ],

  provide: function () {
    return {
      providedFormData: this.providedFormData,
      pageBuilderChildData: this.passDataToChildren
    };
  },

  data () {
    return {
      isLoading: true,
      pageBuilder: null,
      providedFormData: {
        formData: this.formData
      }
    };
  },

  methods: {
    fetchPageBuilderByUuid: function () {
      let urls = $('#api-links').data('api-links');
      let proxy = this;
      let apiUrl = urls.apiRenderPageBuilder + '/' + this.uuid;
      return axios.get(apiUrl, { responseType: 'json' }).then(function (response) {
        proxy.pageBuilder = response.data;

        Vue.set(proxy.pageBuilderData.pageBuilders, proxy.uuid, response.data);
        proxy.isLoading = false;
      });
    },
    fetchPageBuilderByContentName: function () {
      let urls = $('#api-links').data('api-links');
      let proxy = this;
      let apiUrl = urls.apiRenderPageBuilder + '/by-content-name/' + this.contentName;
      return axios.get(apiUrl, { responseType: 'json' }).then(function (response) {
        proxy.pageBuilder = response.data;

        Vue.set(proxy.pageBuilderData.pageBuilders, proxy.contentName, response.data);
        proxy.isLoading = false;
      });
    }
  },

  mounted () {
  },

  created () {
    if (this.uuid) {
      if (!this.pageBuilderData.pageBuilders.hasOwnProperty(this.uuid)) {
        this.pageBuilderData.pageBuilders[this.uuid] = this.fetchPageBuilderByUuid();
      } else {
        let proxy = this;
        Promise.resolve(this.pageBuilderData.pageBuilders[this.uuid]).then(function (value) {
          proxy.pageBuilder = proxy.pageBuilderData.pageBuilders[proxy.uuid];
          proxy.isLoading = false;
        });
      }
    } else {
      if (this.contentName) {
        if (!this.pageBuilderData.pageBuilders.hasOwnProperty(this.contentName)) {
          this.pageBuilderData.pageBuilders[this.contentName] = this.fetchPageBuilderByContentName();
        } else {
          let proxy = this;
          Promise.resolve(this.pageBuilderData.pageBuilders[this.contentName]).then(function (value) {
            proxy.pageBuilder = proxy.pageBuilderData.pageBuilders[proxy.contentName];
            proxy.isLoading = false;
          });
        }
      } else {
        console.log('please add uuid or contentName to load PB data');
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/PageBuilder.js